module.exports = __webpack_public_path__ + "img/1534409274.b4efdd9e.jpg";